import { useTranslation } from 'react-i18next';
import { IsraeliIdChangeBlocker, managementSupportedHref } from './israeliIdChangeBlocker';
import styles from './IsraeliIdChangeImpact.module.css';

interface IsraeliIdChangeBlockerMessageProps {
  blocker: IsraeliIdChangeBlocker;
  contactId: number;
  supportedName: string;
  newIsraeliId: string;
}

/**
 * Why the ID cannot be changed, in a sentence or two, with a link to the card that explains it
 * (HAT-1428). Office-only.
 */
const IsraeliIdChangeBlockerMessage = ({ blocker, contactId, supportedName, newIsraeliId }: IsraeliIdChangeBlockerMessageProps) => {
  const { t } = useTranslation();
  const prefix = 'supportedsManagement.editSupportedDialog.blocked';

  const link = (id: number, label: string) => (
    <a className={styles.link} href={managementSupportedHref(id)} target="_blank" rel="noopener noreferrer">
      {label} ↗
    </a>
  );

  if (blocker.kind === 'representative') {
    return (
      <div className={styles.blocker}>
        <p className={styles.blockerTitle}>
          {t(`${prefix}.representative`, { name: supportedName, funds: blocker.fundIds.join(', ') })}
        </p>
        <p>
          {t(`${prefix}.representativeHint`)} {link(contactId, t(`${prefix}.openCard`, { name: supportedName }))}
        </p>
      </div>
    );
  }

  const holderName = `${blocker.holder.firstName} ${blocker.holder.lastName}`.trim();
  return (
    <div className={styles.blocker}>
      <p className={styles.blockerTitle}>
        {t(blocker.holder.isArchived ? `${prefix}.takenArchived` : `${prefix}.taken`, { id: newIsraeliId, holder: holderName })}
      </p>
      <p>
        {t(`${prefix}.takenHint`, { name: supportedName })} {link(blocker.holder.contactId, t(`${prefix}.openCard`, { name: holderName }))}
      </p>
    </div>
  );
};

export default IsraeliIdChangeBlockerMessage;
